// Cloudinary configuration
export const cloudinaryConfig = {
  cloudName: 'djoqci6b8', // Replace with your actual cloud name
  uploadPreset: 'product_upload', // Replace with your actual upload preset
  // Use asset folder - the component will append the subfolder
  assetFolder: 'EVP Stock'
};

export const cloudName = import.meta.env.VITE_CLOUDINARY_CLOUD_NAME;

// Helper function to get widget configuration
export const getWidgetConfig = () => {
  const uploadFolder = `${cloudinaryConfig.assetFolder}/artworks`;
  console.log('🔧 Cloudinary Widget Config:', {
    uploadFolder,
    assetFolder: cloudinaryConfig.assetFolder
  });

  return {
    cloudName: cloudinaryConfig.cloudName,
    uploadPreset: cloudinaryConfig.uploadPreset,
    folder: uploadFolder,
    sources: ['local', 'camera', 'url'],
    resourceType: 'image',
    clientAllowedFormats: ['jpg', 'jpeg', 'png', 'webp'],
    maxFileSize: 5000000, // 5MB
    multiple: false,
    maxFiles: 1,
    showAdvancedOptions: false,
    cropping: false,
    showSkipCropButton: true,
    showUploadMoreButton: false,
    closeAfterUpload: true,
    showCompletedButton: true,    
    styles: {
      palette: {
        window: '#FFFFFF',
        windowBorder: '#90A0B3',
        tabIcon: '#0078FF',
        menuIcons: '#5A616A',
        textDark: '#000000',
        textLight: '#FFFFFF',
        link: '#0078FF',
        action: '#FF620C',
        inactiveTabIcon: '#0E2F5A',
        error: '#F44235',
        inProgress: '#0078FF',
        complete: '#20B832',
        sourceBg: '#E4EBF1'
      }
    }
  };
};

export default cloudinaryConfig; 